import React, { useState } from "react";
import { Grid, Box, Typography } from "@mui/material";
import PricingCard1 from "./PricingCard1";
import PricingCard2 from "./PricingCard2";
import PricingCard3 from "./PricingCard3";
import PricingCards4 from "./PricingCard4";
import Tooltip from "./Tooltip";

const CardContainer = () => {
  const [isYearly, setIsYearly] = useState(false);
  return (

    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "20px",
          marginTop: { xs: "15px", sm: "10px", md: "10px", lg: "-9%", xl: "-9%" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            height: "70px",
            width: "280px",
            backgroundColor: "rgba(240, 240, 240, 0.2)", // Semi-transparent background for glassmorphism
            backdropFilter: "blur(14px)", // Blur effect for glassmorphism
            border: "2.5px solid rgba(255, 255, 255, 0.4)",
            borderRadius: "32px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            gap: "8px",
          }}
        >
          {/* Monthly Button */}
          <Box
            onClick={() => setIsYearly(false)}
            sx={{
              flex: 1,
              textAlign: "center",
              padding: "10px",
              margin: "6px",
              backgroundColor: !isYearly ? "#12284c" : "transparent",
              color: !isYearly ? "white" : "#000",
              cursor: "pointer",
              transition: "all 0.5s ease-in-out",
              borderRadius: !isYearly ? "25px" : "0",
            }}
          >
            <Typography fontWeight="bold" fontSize="18px">MONTHLY</Typography>
          </Box>

          {/* Yearly Button */}
          <Box
            onClick={() => setIsYearly(true)}
            sx={{
              flex: 1,
              textAlign: "center",
              padding: "10px",
              margin: "6px",
              backgroundColor: isYearly ? "#12284c" : "transparent",
              color: isYearly ? "white" : "#000",
              cursor: "pointer",
              transition: "all 0.5s ease-in-out",
              borderRadius: isYearly ? "25px" : "0",
            }}
          >
            <Typography fontWeight="bold" fontSize="18px">YEARLY</Typography>
          </Box>
        </Box>
        <Tooltip />
      </Box>
      <Box
        sx={{
          overflowX: "none",
          display: "flex",
          justifyContent: { lg: "center", xl: "center" },
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            flexWrap: { xs: "wrap", sm: "wrap", md: "wrap", lg: "nowrap", xl: "nowrap" },
            width: { xl: "72%", lg: "90%", md: "100%", sm: "100%", xs: "100%" },
            justifyContent: { xs: "center", sm: "flex-start", md: "center", lg: "center", xl: "center" },
            paddingX: { xs: "16px", sm: "16px", md: "0px" },
            pb: 4,
            height: { xs: "400px", sm: "auto", md: "auto", lg: "auto", xl: "auto" },
            overflow: { xs: "auto", sm: "none", md: "none", lg: "none", xl: "none" }

          }}
        >
          {/* Four unique PricingCards */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            sx={{
              flexShrink: 0,
              maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
            }}
          >
            <PricingCard1 isYearly={isYearly} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            sx={{
              flexShrink: 0,
              maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
            }}
          >
            <PricingCard2 isYearly={isYearly} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            sx={{
              flexShrink: 0,
              maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
            }}
          >
            <PricingCard3 isYearly={isYearly} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            sx={{
              flexShrink: 0,
              maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
            }}
          >
            <PricingCards4 isYearly={isYearly} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default CardContainer;





// import React, { useState } from "react";
// import { Grid, Box, Typography } from "@mui/material";
// import PricingCard1 from "./PricingCard1";
// import PricingCard2 from "./PricingCard2";
// import PricingCard3 from "./PricingCard3";
// import PricingCards4 from "./PricingCard4";
// import Tooltip from "./Tooltip";

// const CardContainer = () => {
//   const [isYearly, setIsYearly] = useState(false);
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           marginBottom: "20px",
//           marginTop: { xs: "15px", sm: "10px", md: "10px", lg: "-9%", xl: "-9%" },
//           position: "relative",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "center",
//             alignItems: "center",
//             position: "relative",
//             height: "70px",
//             width: "280px",
//             backgroundColor: "rgba(240, 240, 240, 0.2)",
//             backdropFilter: "blur(14px)",
//             border: "2px solid rgba(255, 255, 255, 0.4)",
//             borderRadius: "32px",
//             boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
//             overflow: "hidden",
//             gap: "8px",
//           }}
//         >
//           {/* Monthly Button */}
//           <Box
//             onClick={() => setIsYearly(false)}
//             sx={{
//               flex: 1,
//               textAlign: "center",
//               padding: "10px",
//               margin: "6px",
//               backgroundColor: !isYearly ? "#12284c" : "transparent",
//               color: !isYearly ? "white" : "#000",
//               cursor: "pointer",
//               transition: "all 0.5s ease-in-out",
//               borderRadius: !isYearly ? "25px" : "0",
//             }}
//           >
//             <Typography fontWeight="bold" fontSize="18px">MONTHLY</Typography>
//           </Box>

//           {/* Yearly Button */}
//           <Box
//             onClick={() => setIsYearly(true)}
//             sx={{
//               flex: 1,
//               textAlign: "center",
//               padding: "10px",
//               margin: "6px",
//               backgroundColor: isYearly ? "#12284c" : "transparent",
//               color: isYearly ? "white" : "#000",
//               cursor: "pointer",
//               transition: "all 0.5s ease-in-out",
//               borderRadius: isYearly ? "25px" : "0",
//             }}
//           >
//             <Typography fontWeight="bold" fontSize="18px">YEARLY</Typography>
//           </Box>
//         </Box>
//         <Tooltip />
//       </Box>
//       <Box
//         sx={{
//           overflowX: { xs: "auto", sm: "auto", md: "none", lg: "none", xl: "none" },
//           display: "flex",
//           justifyContent: { lg: "center", xl: "center" },
//           "&::-webkit-scrollbar": {
//             display: "none",
//           },
//           scrollbarWidth: "none",
//         }}
//       >
//         <Grid
//           container
//           spacing={1}
//           sx={{
//             flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap", xl: "nowrap" },
//             flexDirection: { xs: "column", sm: "column", md: "row", lg: "row", xl: "row" },
//             alignItems: { xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" },
//             width: { xs: "100%", sm: "100%", md: "100%", lg: "90%", xl: "72%" },
//             justifyContent: { xs: "center", sm: "center", md: "center", lg: "center", xl: "center" },
//             paddingX: { xs: "16px", sm: "16px", md: "0px" },
//             pb: 4,
//           }}
//         >
//           {/* PricingCard1 */}
//           <Grid
//             item
//             xs={12}
//             sm={12}
//             md={4}
//             lg={3}
//             xl={3}
//             sx={{
//               maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
//               width: { xs: "100%", sm: "100%", md: "auto", lg: "auto", xl: "auto" },
//               mb: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 },
//             }}
//           >
//             <PricingCard1 isYearly={isYearly} />
//           </Grid>
//           {/* PricingCard2 - Sticky on mobile */}
//           <Grid
//             item
//             xs={12}
//             sm={12}
//             md={4}
//             lg={3}
//             xl={3}
//             sx={{
//               maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
//               width: { xs: "100%", sm: "100%", md: "auto", lg: "auto", xl: "auto" },
//               mb: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 },
//               position: { xs: "sticky", sm: "sticky", md: "static", lg: "static", xl: "static" },
//               top: { xs: "0px", sm: "0px" },
//               zIndex: { xs: 10, sm: 10, md: 0, lg: 0, xl: 0 },
//               backgroundColor: { xs: "#fff", sm: "#fff", md: "transparent", lg: "transparent", xl: "transparent" },
//             }}
//           >
//             <PricingCard2 isYearly={isYearly} />
//           </Grid>
//           {/* PricingCard3 */}
//           <Grid
//             item
//             xs={12}
//             sm={12}
//             md={4}
//             lg={3}
//             xl={3}
//             sx={{
//               maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
//               width: { xs: "100%", sm: "100%", md: "auto", lg: "auto", xl: "auto" },
//               mb: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 },
//             }}
//           >
//             <PricingCard3 isYearly={isYearly} />
//           </Grid>
//           {/* PricingCard4 */}
//           <Grid
//             item
//             xs={12}
//             sm={12}
//             md={4}
//             lg={3}
//             xl={3}
//             sx={{
//               maxWidth: { xs: "300px", sm: "300px", md: "300px", lg: "25%", xl: "25%" },
//               width: { xs: "100%", sm: "100%", md: "auto", lg: "auto", xl: "auto" },
//               mb: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 },
//             }}
//           >
//             <PricingCards4 isYearly={isYearly} />
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>
//   );
// };

// export default CardContainer;

